/*
 * Büyülütaş: hareket katmanı.
 *
 * Marka kararı gereği animasyonlar "hareketi azalt" tercihinden bağımsız çalışır.
 *
 * [data-reveal]       görünüme girince .is-in alır ("image": görsel yavaşça yerine oturur, "fade": yalnızca belirme)
 * [data-lines]        içindeki .bt-line satırları sırayla maskeden yükselir
 * [data-split]        başlığı kelimelere böler; kelimeler satır maskesinden yükselir
 * otomatik belirme    Prestige'in ürün ızgarası, ürün bilgileri, footer ve sayfa metinleri de aynı dille belirir
 * <bt-wish-button>    ürün kartındaki kalp; favoriler tarayıcıda saklanır
 * <bt-wish-count>     header'daki favori sayısı
 * <bt-wishlist>       favori çekmecesinin listesi
 * <bt-rail>           yatay ürün rayı: fareyle sürükleme, oklar, ilerleme çizgisi
 * galeri sayacı      ürün galerisinde görünen görselin sırası ("1 / 5")
 * <bt-price-range>    koleksiyon filtre çubuğundaki iki tutamaklı fiyat aralığı; sıralama seçimi de adres çubuğundan uygulanır
 * <bt-insta-feed>     Instagram şeridindeki kareleri hesabın son gönderileriyle değiştirir; akış gelmezse elle seçilenler kalır
 * header payı         kaydırınca küçülen header'ın boşalttığı yüksekliği alt boşlukla doldurur (titreme döngüsünü önler)
 */

/* Kelime bölme ------------------------------------------------------------------------------------------------------ */

function splitWords(element, className) {
  if (element.dataset.splitDone) return;
  element.dataset.splitDone = 'true';

  let index = 0;
  const walk = (node) => {
    [...node.childNodes].forEach((child) => {
      if (child.nodeType === Node.TEXT_NODE) {
        const fragment = document.createDocumentFragment();
        child.textContent.split(/(\s+)/).forEach((part) => {
          if (!part) return;
          if (/^\s+$/.test(part)) {
            fragment.append(document.createTextNode(' '));
            return;
          }
          const outer = document.createElement('span');
          outer.className = className;
          const inner = document.createElement('span');
          inner.textContent = part;
          inner.style.setProperty('--wi', index++);
          outer.append(inner);
          fragment.append(outer);
        });
        child.replaceWith(fragment);
      } else if (child.nodeType === Node.ELEMENT_NODE && child.tagName !== 'BR') {
        walk(child);
      }
    });
  };
  walk(element);
}

/* Görünüme girme ---------------------------------------------------------------------------------------------------- */

// Görseller kendi kutuları yerine üst öğeleri üzerinden izlenir: ölçeklenen ya da kırpılan hedefte kesişim
// güvenilir değildir.
const revealTargets = new WeakMap();

const revealObserver = new IntersectionObserver((entries) => {
  entries.forEach((entry) => {
    if (!entry.isIntersecting) return;
    // Ebeveyn kendisi de belirme hedefi olabilir
    const targets = revealTargets.get(entry.target) || [];
    if (!targets.length || entry.target.matches('[data-reveal], [data-split], [data-lines]')) targets.push(entry.target);
    targets.forEach((target) => target.classList.add('is-in'));
    revealTargets.delete(entry.target);
    revealObserver.unobserve(entry.target);
  });
}, { rootMargin: '0px 0px -8% 0px', threshold: 0 });

function observeReveal(element) {
  if (element.dataset.reveal !== 'image') {
    revealObserver.observe(element);
    return;
  }
  const anchor = element.parentElement;
  const list = revealTargets.get(anchor) || [];
  list.push(element);
  revealTargets.set(anchor, list);
  revealObserver.observe(anchor);
}

/* Otomatik belirme: tema bölümlerine tek tek öznitelik yazmadan aynı hareket dili ------------------------------- */

// Ürün ızgarası Prestige'in kendi kart belirme animasyonunu kullanır (hareket her zaman açık olduğu için çalışır).
const AUTO_REVEAL = [
  ['.collection-toolbar', () => 0, 'fade'],
  ['.footer__block', (el, i) => i],
  ['.footer__aside', () => 2, 'fade'],
  ['.blog-post-card', (el, i) => i % 3],
  ['.section-header', () => 0],
];

function autoMotion(scope) {
  AUTO_REVEAL.forEach(([selector, index, type]) => {
    scope.querySelectorAll(selector).forEach((element, i) => {
      if (element.hasAttribute('data-reveal') || element.closest('[data-reveal]')) return;
      element.setAttribute('data-reveal', type || '');
      element.style.setProperty('--i', index(element, i));
    });
  });
}

/* Başlatma ---------------------------------------------------------------------------------------------------------- */

function init(scope = document) {
  autoMotion(scope);
  scope.querySelectorAll('[data-split]').forEach((element) => splitWords(element, 'bt-w'));

  scope.querySelectorAll('[data-lines]').forEach((element) => {
    element.querySelectorAll('.bt-line > span').forEach((line, i) => line.style.setProperty('--l', i));
  });

  scope.querySelectorAll('[data-reveal], [data-split], [data-lines]').forEach(observeReveal);
}

/* Ürün galerisi sayacı: kaydırma konumundan görünen görselin sırası --------------------------------------------- */

document.addEventListener('scroll', (event) => {
  const carousel = event.target;
  if (!(carousel instanceof Element) || !carousel.classList.contains('product-gallery__carousel')) return;
  const output = carousel.closest('.product-gallery')?.querySelector('[data-bt-gallery-index]');
  if (!output) return;
  const index = Math.round(Math.abs(carousel.scrollLeft) / Math.max(carousel.clientWidth, 1)) + 1;
  output.textContent = String(index);
}, { capture: true, passive: true });

/* Ürün rayı --------------------------------------------------------------------------------------------------------- */

if (!customElements.get('bt-rail')) {
  customElements.define('bt-rail', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.bt-rail__track');
      this.bar = this.querySelector('.bt-rail__progress');
      const scope = this.closest('section') || this;
      this.prev = scope.querySelector('[data-rail-prev]');
      this.next = scope.querySelector('[data-rail-next]');
      if (!this.track) return;

      this.onResize = () => this.sync();
      this.track.addEventListener('scroll', () => this.sync(), { passive: true });
      this.prev?.addEventListener('click', () => this.step(-1));
      this.next?.addEventListener('click', () => this.step(1));
      window.addEventListener('resize', this.onResize, { passive: true });
      this.enableDrag();
      this.sync();
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.onResize);
    }

    step(direction) {
      const item = this.track.querySelector(':scope > li');
      const width = item ? item.getBoundingClientRect().width : this.track.clientWidth * 0.8;
      const perView = Math.max(1, Math.floor(this.track.clientWidth / width));
      this.track.scrollBy({ left: direction * width * perView, behavior: 'smooth' });
    }

    sync() {
      const max = this.track.scrollWidth - this.track.clientWidth;
      const visible = this.track.clientWidth / this.track.scrollWidth;
      const progress = max > 0 ? this.track.scrollLeft / max : 1;
      this.bar?.style.setProperty('--progress', (visible + (1 - visible) * progress).toFixed(3));
      if (this.prev) this.prev.disabled = this.track.scrollLeft <= 2;
      if (this.next) this.next.disabled = this.track.scrollLeft >= max - 2;
      this.toggleAttribute('data-static', max <= 2);
      this.closest('section')?.toggleAttribute('data-rail-static', max <= 2);
    }

    enableDrag() {
      const track = this.track;
      let startX = 0;
      let startScroll = 0;
      let moved = false;

      track.addEventListener('pointerdown', (event) => {
        if (event.pointerType !== 'mouse' || event.button !== 0) return;
        startX = event.clientX;
        startScroll = track.scrollLeft;
        moved = false;
        const move = (e) => {
          const dx = e.clientX - startX;
          if (!moved && Math.abs(dx) > 6) {
            moved = true;
            track.classList.add('is-dragging');
          }
          if (moved) track.scrollLeft = startScroll - dx;
        };
        const up = () => {
          window.removeEventListener('pointermove', move);
          window.removeEventListener('pointerup', up);
          requestAnimationFrame(() => track.classList.remove('is-dragging'));
        };
        window.addEventListener('pointermove', move);
        window.addEventListener('pointerup', up);
      });

      track.addEventListener('click', (event) => {
        if (moved) {
          event.preventDefault();
          moved = false;
        }
      }, true);

      track.addEventListener('dragstart', (event) => event.preventDefault());
    }
  });
}

/* Favoriler -------------------------------------------------------------------------------------------------------- */

const WISH_KEY = 'bt-wishlist';

const wishlist = {
  read() {
    try {
      const list = JSON.parse(localStorage.getItem(WISH_KEY) || '[]');
      return Array.isArray(list) ? list : [];
    } catch (error) {
      return [];
    }
  },

  write(list) {
    try {
      localStorage.setItem(WISH_KEY, JSON.stringify(list));
    } catch (error) {
      // Gizli pencere gibi depolamanın kapalı olduğu durumlarda liste yalnızca bu sayfada kalır
    }
    document.dispatchEvent(new CustomEvent('bt:wishlist', { detail: { list } }));
  },

  has(handle) {
    return this.read().includes(handle);
  },

  toggle(handle) {
    const list = this.read();
    const next = list.includes(handle) ? list.filter((item) => item !== handle) : [handle, ...list];
    this.write(next);
    return next.includes(handle);
  },

  remove(handle) {
    this.write(this.read().filter((item) => item !== handle));
  },
};

function formatMoney(cents) {
  const format = window.themeVariables?.settings?.moneyFormat || '{{amount}} TL';
  const value = (cents / 100).toFixed(2);
  const [whole, decimals] = value.split('.');
  const group = (separator) => whole.replace(/\B(?=(\d{3})+(?!\d))/g, separator);
  return format.replace(/{{\s*(\w+)\s*}}/, (match, key) => {
    switch (key) {
      case 'amount_no_decimals': return group(',');
      case 'amount_with_comma_separator': return `${group('.')},${decimals}`;
      case 'amount_no_decimals_with_comma_separator': return group('.');
      case 'amount_with_period_and_space_separator': return `${group(' ')}.${decimals}`;
      default: return `${group(',')}.${decimals}`;
    }
  });
}

const escapeHtml = (value) => String(value).replace(/[&<>"']/g, (char) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[char]);

if (!customElements.get('bt-wish-button')) {
  customElements.define('bt-wish-button', class extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('button');
      this.handle = this.getAttribute('handle');
      this.onChange = () => this.sync();
      this.button.addEventListener('click', (event) => {
        event.preventDefault();
        const added = wishlist.toggle(this.handle);
        if (added) {
          this.classList.remove('is-popping');
          void this.offsetWidth;
          this.classList.add('is-popping');
        }
      });
      document.addEventListener('bt:wishlist', this.onChange);
      this.sync();
    }

    disconnectedCallback() {
      document.removeEventListener('bt:wishlist', this.onChange);
    }

    sync() {
      const active = wishlist.has(this.handle);
      this.classList.toggle('is-active', active);
      this.button.setAttribute('aria-pressed', String(active));
      this.button.setAttribute('aria-label', this.button.dataset[active ? 'labelRemove' : 'labelAdd']);
    }
  });
}

if (!customElements.get('bt-wish-count')) {
  customElements.define('bt-wish-count', class extends HTMLElement {
    connectedCallback() {
      this.onChange = () => this.sync();
      document.addEventListener('bt:wishlist', this.onChange);
      this.sync();
    }

    disconnectedCallback() {
      document.removeEventListener('bt:wishlist', this.onChange);
    }

    sync() {
      const count = wishlist.read().length;
      this.textContent = count;
      this.hidden = count === 0;
    }
  });
}

if (!customElements.get('bt-wishlist')) {
  customElements.define('bt-wishlist', class extends HTMLElement {
    connectedCallback() {
      this.list = this.querySelector('.bt-wishlist__list');
      this.drawer = this.closest('x-drawer');
      this.cache = new Map();
      this.onChange = () => this.render();

      document.addEventListener('bt:wishlist', this.onChange);
      this.drawer?.addEventListener('dialog:before-show', () => this.render());

      this.list.addEventListener('click', (event) => {
        const remove = event.target.closest('[data-remove]');
        if (remove) wishlist.remove(remove.dataset.remove);
      });

      // Sepete eklenince favori çekmecesi kapanır, Prestige'in sepet çekmecesi açılır
      this.addEventListener('variant:add', () => this.drawer?.hide());
      this.toggleAttribute('data-empty', wishlist.read().length === 0);
    }

    disconnectedCallback() {
      document.removeEventListener('bt:wishlist', this.onChange);
    }

    async fetchProduct(handle) {
      if (this.cache.has(handle)) return this.cache.get(handle);
      const request = fetch(`${window.Shopify?.routes?.root || '/'}products/${encodeURIComponent(handle)}.js`)
        .then((response) => (response.ok ? response.json() : null))
        .catch(() => null);
      this.cache.set(handle, request);
      return request;
    }

    async render() {
      const handles = wishlist.read();
      this.toggleAttribute('data-empty', handles.length === 0);
      if (handles.length === 0) {
        this.list.replaceChildren();
        return;
      }

      const products = await Promise.all(handles.map((handle) => this.fetchProduct(handle)));
      const missing = handles.filter((handle, i) => !products[i]);
      if (missing.length) {
        wishlist.write(handles.filter((handle) => !missing.includes(handle)));
        return;
      }

      this.list.innerHTML = products.map((product, i) => this.item(product, i)).join('');
    }

    item(product, index) {
      const image = product.featured_image ? `${product.featured_image}${product.featured_image.includes('?') ? '&' : '?'}width=240` : '';
      const variant = product.variants.find((item) => item.available) || product.variants[0];
      const price = product.price_varies ? `${formatMoney(product.price_min)}+` : formatMoney(product.price);
      const title = escapeHtml(product.title);
      const root = window.Shopify?.routes?.root || '/';

      let action = '<span class="bt-label bt-label--muted">Tükendi</span>';
      if (product.available && product.variants.length === 1) {
        action = `
          <product-form>
            <form method="post" action="${root}cart/add" accept-charset="UTF-8" enctype="multipart/form-data">
              <input type="hidden" name="id" value="${variant.id}">
              <input type="hidden" name="quantity" value="1">
              <input type="hidden" name="on_success" value="force_open_drawer">
              <button type="submit" class="bt-btn bt-btn--small">Sepete ekle</button>
            </form>
          </product-form>`;
      } else if (product.available) {
        action = `<a href="${product.url}" class="bt-btn bt-btn--small">Seçenekler</a>`;
      }

      return `
        <li class="bt-wishlist__item" style="--i: ${Math.min(index, 6)}">
          <a href="${product.url}" class="bt-wishlist__media">${image ? `<img src="${image}" alt="" loading="lazy" width="120" height="120">` : ''}</a>
          <div class="bt-wishlist__info">
            <a href="${product.url}" class="bt-wishlist__title">${title}</a>
            <span class="bt-wishlist__price">${price}</span>
            <div class="bt-wishlist__actions">
              ${action}
              <button type="button" class="bt-wishlist__remove" data-remove="${escapeHtml(product.handle)}">Kaldır</button>
            </div>
          </div>
        </li>`;
    }
  });
}

/* Koleksiyon filtre çubuğu ----------------------------------------------------------------------------------------- */

// İki tutamaklı fiyat aralığı: sürüklerken kutular güncellenir, bırakınca adres çubuğu üzerinden filtre uygulanır.
if (!customElements.get('bt-price-range')) {
  customElements.define('bt-price-range', class extends HTMLElement {
    connectedCallback() {
      this.inputs = [...this.querySelectorAll('input[type="range"]')];
      this.boxes = [this.querySelector('[data-min]'), this.querySelector('[data-max]')];
      this.max = Number(this.dataset.rangeMax) || 0;
      this.inputs.forEach((input, index) => {
        input.addEventListener('input', () => this.update(index));
        input.addEventListener('change', () => this.apply());
      });
      this.update();
    }

    update(changed) {
      let [low, high] = this.inputs.map((input) => Number(input.value));
      if (low > high) {
        if (changed === 0) low = high;
        else high = low;
        this.inputs[0].value = low;
        this.inputs[1].value = high;
      }
      const percent = (value) => (this.max ? (value / this.max) * 100 : 0);
      this.style.setProperty('--from', `${percent(low)}%`);
      this.style.setProperty('--to', `${percent(high)}%`);
      this.boxes[0].textContent = `${new Intl.NumberFormat('tr-TR').format(low)} TL`;
      this.boxes[1].textContent = `${new Intl.NumberFormat('tr-TR').format(high)} TL`;
    }

    apply() {
      const [low, high] = this.inputs.map((input) => Number(input.value));
      const url = new URL(window.location.href);
      url.searchParams.delete('page');
      if (low > 0) url.searchParams.set(this.dataset.minParam, low);
      else url.searchParams.delete(this.dataset.minParam);
      if (high < this.max) url.searchParams.set(this.dataset.maxParam, high);
      else url.searchParams.delete(this.dataset.maxParam);
      window.location.assign(url);
    }
  });
}

document.addEventListener('change', (event) => {
  const select = event.target.closest?.('select[data-bt-sort]');
  if (!select) return;
  const url = new URL(window.location.href);
  url.searchParams.delete('page');
  url.searchParams.set('sort_by', select.value);
  window.location.assign(url);
});

/* Header payı -----------------------------------------------------------------------------------------------------
   Header yapışkandır ve sayfa akışındadır; kaydırınca (.is-solid) küçülür. Küçülme alttaki içeriği yukarı iterse
   tarayıcının kaydırma sabitlemesi sayfayı geri çeker, header yeniden büyür ve döngü her karede tekrarlanır
   (ekran titrer). Bölümün alt boşluğu, header'ın açık hâline göre eksilen yüksekliği her an tamamlar; böylece
   içerik yerinden oynamaz. */

(() => {
  const section = document.querySelector('.shopify-section--header');
  const header = section?.querySelector('.header');
  if (!header || !('ResizeObserver' in window)) return;
  let full = 0;
  new ResizeObserver(() => {
    const height = header.getBoundingClientRect().height;
    if (!header.classList.contains('is-solid')) full = height;
    section.style.marginBottom = full > height ? `${(full - height).toFixed(2)}px` : '';
  }).observe(header);
  window.addEventListener('resize', () => {
    if (header.classList.contains('is-solid')) return;
    full = header.getBoundingClientRect().height;
  }, { passive: true });
})();

/* Instagram şeridi: canlı akış ------------------------------------------------------------------------------------ */

// Kareler sunucuda elle seçilen görsellerle gelir; Instagram yanıt verirse aynı işaretlemenin içinde görsel ve bağlantı
// yerinde değiştirilir, böylece belirme hareketi ve düzen aynen kalır. Yanıt tarayıcıda bir saat saklanır.
// Anahtar, Instagram hesabının bağlı olduğu Facebook sayfasının salt okuma izinli sayfa anahtarıdır (süresiz).
const INSTA_CACHE = 'bt-insta';
const INSTA_TTL = 60 * 60 * 1000;
const INSTA_API = 'https://graph.facebook.com/v23.0';

customElements.define('bt-insta-feed', class extends HTMLElement {
  connectedCallback() {
    if (!this.dataset.token || this.dataset.loaded) return;
    this.dataset.loaded = 'true';
    this.load().then((posts) => this.render(posts)).catch(() => {});
  }

  async load() {
    try {
      const cached = JSON.parse(localStorage.getItem(INSTA_CACHE));
      if (cached && Date.now() - cached.time < INSTA_TTL && cached.posts.length) return cached.posts;
    } catch {}

    const fields = 'media_type,media_url,thumbnail_url,permalink,caption';
    const response = await fetch(`${INSTA_API}/${this.dataset.account}/media?fields=${fields}&limit=12&access_token=${this.dataset.token}`);
    const { data } = await response.json();
    const posts = data
      .map((item) => ({
        url: item.permalink,
        image: item.media_type === 'VIDEO' ? item.thumbnail_url : item.media_url,
        alt: (item.caption || '').split('\n')[0].slice(0, 120),
      }))
      .filter((post) => post.url && post.image);

    try {
      localStorage.setItem(INSTA_CACHE, JSON.stringify({ time: Date.now(), posts }));
    } catch {}
    return posts;
  }

  render(posts) {
    const items = [...this.querySelectorAll('.bt-insta__item')];
    posts.slice(0, items.length).forEach((post, i) => {
      const img = document.createElement('img');
      img.src = post.image;
      img.alt = post.alt;
      img.loading = 'lazy';
      img.decoding = 'async';
      img.referrerPolicy = 'no-referrer';
      items[i].querySelector(':scope > img, :scope > svg')?.replaceWith(img);
      items[i].href = post.url;
    });
  }
});

init();

/* Tema editörü: yeniden yüklenen bölümleri yeniden başlat */
document.addEventListener('shopify:section:load', (event) => init(event.target));

/* Çekmeceden çekmeceye geçiş: hesap çekmecesindeki "Favorilerim" ya da mobil menüdeki "Giriş yap" gibi başka bir
   çekmeceyi açan düğmeler, içinde bulundukları çekmeceyi kapatır; iki çekmece üst üste kalmaz. */
document.addEventListener('click', (event) => {
  const trigger = event.target.closest?.('[aria-controls]');
  if (!trigger) return;
  const current = trigger.closest('x-drawer, header-sidebar, cart-drawer');
  const target = document.getElementById(trigger.getAttribute('aria-controls'));
  if (current && target && target !== current && target.matches('x-drawer, cart-drawer')) {
    current.hide?.();
  }
});
